import { graphql } from "@/lib/gql/__generated__";

export const OPTION_PMS_OPTION_LIST_FOR_OPTION_PMS = graphql(/* GraphQL */ `
	query OptionPmsOptionListForOptionPms($hotelID: ID!) {
		optionPmsOptionList(hotelID: $hotelID) {
			id
			options {
				optionID
				name
			}
		}
	}
`);
